import { cn } from '@/platform/lib/utils';

const alignments = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
};

const TableCell = ({
    textAlign,
    singleLine = false,
    collapsing = false,
    className,
    children,
    ...props
}) => (
    <td
        className={cn(
            'px-3 py-2 align-middle first:pl-4 last:pr-4',
            '[&_a]:text-primary-600 [&_a:hover]:text-primary-700',
            alignments[textAlign],
            singleLine && 'whitespace-nowrap',
            collapsing && 'w-px whitespace-nowrap',
            className
        )}
        {...props}
    >
        {children}
    </td>
);

export default TableCell;
